export const Prefer = Object.freeze({
	Theme: 'preferTheme',
	Light: 'light',
	Dark: 'dark',
});
